import { AxiosService } from 'src/axios/axios.service';
import { tQuotaExceededCountResponse } from './ActiveLeadsQuotaBanner.types';

// Fronts the bff-web proxy (default axios base) for the workspace-wide count
// of quota-hidden conversations. Any non-200 rejects; the banner treats a
// rejection as "count unavailable" and renders without the count line (R8).
export const ActiveLeadsQuotaBannerService = Object.freeze({
  getQuotaExceededCount: async function (
    workspaceId: string,
  ): Promise<tQuotaExceededCountResponse> {
    return AxiosService.get<tQuotaExceededCountResponse>(
      `/workspace/${workspaceId}/leads/quota-exceeded-count`,
    );
  },
});
